import { render, staticRenderFns } from "./NotesModalForm.vue?vue&type=template&id=63d11f7a&"
import script from "./NotesModalForm.vue?vue&type=script&lang=js&"
export * from "./NotesModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports